module.exports = __webpack_public_path__ + "static/black2-e30645604e0b505fcaf42cac98095342.png";